//#region IMPORT
import React, { useEffect } from 'react';
import {
  Card as MuiCard,
  Button as MuiButton,
  Box as MuiBox,
  Stack,
  TextField,
  Box,
  TableContainer,
  Table,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  Typography,
  Popper,
  Grow,
  ClickAwayListener,
  MenuList,
  MenuItem,
  Divider,
  IconButton,
  Slide,
  Tooltip,
  styled,
  tooltipClasses,
} from '@mui/material';
import {
  Search as SearchIcon,
  Add as AddIcon,
  Save as SaveIcon,
  Delete as DeleteIcon,
  Print as PrintIcon,
  DriveFolderUpload as FileUploadIcon,
  Refresh as RefreshIcon,
  Copyright as CopyrightIcon,
} from '@mui/icons-material';
import {
  Button,
  DatePicker,
  Combo,
  Checkbox,
  GroupCheckbox,
  Radio,
  FRadio,
  DateTimePicker,
  Dialog,
} from '../../Components/MUIs';
import Split from 'react-split';
import GridFunctions from '../../Services/agGrid/ag-Grid-functions';
import { AgGridReact } from 'ag-grid-react';
import Icon from '../../Assets/Icon/CustomIcons';
import Commons from '../../Services/Common/Common';
import FilePreview from '../FilePreview/FilePreview';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { resetAddButtonError } from '../../Reducer/StatusFlagsReducer';
// 필터관련 컴포넌트
import { GridFilterButton } from '../../Components/GridFilterButton';
import { GridFilterSummary } from '../../Components/GridFilterSummary';

// import { setChanged, setSelected } from '../../Reducer/GridReducer';
//#endregion
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

// 커스터마이징된 Tooltip 생성
const LargeTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#4CAF50', // 본체 배경 초록
    color: '#fff',
    fontSize: '0.9rem',
    padding: theme.spacing(1),
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: '#4CAF50', // 꼬리도 동일 색으로!
  },
}));

function BusinessCommon({
  gridId,
  getRowId,
  gridRef,
  gridRef2,
  columnDefs,
  rowData,
  setSelectedRowData,
  setChangedRowData,
  editable = false,
  onSelectionChanged,
  onCellValueChanged,
  onCellClicked,
  pagination = true,
  rowDragManaged = false,
  onRowDragEnd,
  autoGroupColumnDef = {},
  tableData = [],
  previewRender = null,
  viewMode,
  colWidth,
  // FilePreview props
  selectedRowData = [],
  fileNameField,
  filePathField,
  filePreviewHeight = '600px',
  title1 = '기본정보',
  title2 = '상세정보',
  leftSize = 50,
  rightSize = 50,
  gridSide = 'left',
  suppressCellFocus = true,

  /* Button Props */
  // left side
  buttonsSx1, // object
  searchClick1 = () => {},
  addClick1 = () => {},
  saveClick1 = () => {},
  deleteClick1 = () => {},
  printClick1 = () => {},
  fileUploadClick1 = () => {},
  fileDownloadClick1 = () => {},
  refreshClick1 = () => {},
  applyClick1 = () => {},
  applyCancleClick1 = () => {},
  copyClick1 = () => {},
  validateSelection = () => {},
  // right side
  buttonsSx2, // object
  searchClick2 = () => {},
  addClick2 = () => {},
  saveClick2 = () => {},
  deleteClick2 = () => {},
  printClick2 = () => {},
  fileUploadClick2 = () => {},
  refreshClick2 = () => {},
  applyClick2 = () => {},
  applyCancleClick2 = () => {},
  copyClick2 = () => {},

  /* Stack Props */
  // left side
  searchYn1 = 'N', // string
  copyYn1 = 'N', // string
  addYn1 = gridSide === 'left' ? 'Y' : 'N', // string
  saveYn1 = 'N', // string
  deleteYn1 = gridSide === 'left' ? 'Y' : 'N', // string
  printYn1 = 'N', // string
  multiPrintYn1 = 'N', // string
  other1, // object
  printItem1 = [],
  fileUploadYn1 = 'N', // string
  fileDownloadYn1 = 'N', // string
  refreshYn1 = gridSide === 'left' ? 'Y' : 'N', // string
  applyYn1 = 'N', // string
  applyName1 = '', //string
  applyCancleName1 = '', //string
  // right side
  searchYn2 = 'N', // string
  copyYn2 = 'N', // string
  addYn2 = gridSide === 'left' ? 'N' : 'Y', // string
  saveYn2 = 'N', // string
  deleteYn2 = gridSide === 'left' ? 'N' : 'Y', // string
  printYn2 = 'N', // string
  multiPrintYn2 = 'N', // string
  other2, // object
  printItem2 = [],
  fileUploadYn2 = 'N', // string
  refreshYn2 = gridSide === 'left' ? 'N' : 'Y', // string
  applyYn2 = 'N', // string
  applyName2 = '', //string
  applyCancleName2 = '', //string
}) {
  // const dispatch = useDispatch();
  // const gridState = useSelector((state) => state.grid[gridId]) || {
  //   rowData: [],
  //   selected: [],
  //   changed: [],
  //   deleted: [],
  // };

  // 필터관련
  const [gridApi, setGridApi] = React.useState(null);
  const [gridColumnApi, setGridColumnApi] = React.useState(null);
  const [selectedFilters, setSelectedFilters] = React.useState({});
  const [headerMap, setHeaderMap] = React.useState({});
  const [isFiltered, setIsFiltered] = React.useState(false);
  const selectedFiltersRef = React.useRef(selectedFilters);

  useEffect(() => {
    selectedFiltersRef.current = selectedFilters;
    if (gridRef?.current?.api) {
      gridRef.current.api.onFilterChanged(); // 필터 적용
    }
  }, [selectedFilters]);

  // INFO
  const { custInfo, menuInfo } = useSelector((state) => state.BaseInfo);
  const isAddButtonError = useSelector(
    (state) => state.StatusFlags.isAddButtonError
  );

  const dispatch = useDispatch();
  const location = useLocation();
  const currentPath = location.pathname.split('/').pop(); // 현재 경로 주소
  const proId = menuInfo.filter((e) => e.menuId === currentPath)[0].proId; // 프로그램 ID
  const [open1, setOpen1] = React.useState(false);
  const [open2, setOpen2] = React.useState(false);
  const anchorRef1 = React.useRef(null);
  const anchorRef2 = React.useRef(null);
  const [dialogToggle1, setDialogToggle1] = React.useState({
    open: false,
    title: '',
    content: <></>,
    contentText: '',
    actions: <></>,
  });
  const [dialogToggle2, setDialogToggle2] = React.useState({
    open: false,
    title: '',
    content: <></>,
    contentText: '',
    actions: <></>,
  });
  useEffect(() => {
    if (isAddButtonError) {
      const timer = setTimeout(() => {
        dispatch(resetAddButtonError());
      }, 8000);

      return () => clearTimeout(timer);
    }
  }, [isAddButtonError]);
  const HandleToggle1 = () => {
    setOpen1((prevOpen) => !prevOpen);
  };
  const HandleToggle2 = () => {
    setOpen2((prevOpen) => !prevOpen);
  };
  const HandleClose1 = (event) => {
    if (anchorRef1.current && anchorRef1.current.contains(event.target)) {
      return;
    }

    setOpen1(false);
  };
  const HandleClose2 = (event) => {
    if (anchorRef2.current && anchorRef2.current.contains(event.target)) {
      return;
    }

    setOpen2(false);
  };
  function HandleListKeyDown1(event) {
    if (event.key === 'Tab') {
      event.preventDefault();
      setOpen1(false);
    } else if (event.key === 'Escape') {
      setOpen1(false);
    }
  }
  function HandleListKeyDown2(event) {
    if (event.key === 'Tab') {
      event.preventDefault();
      setOpen2(false);
    } else if (event.key === 'Escape') {
      setOpen2(false);
    }
  }

  //item : tableData
  const TableConditions = (item) => {
    switch (item.type) {
      case 'button':
        return (
          <Button
            name={item.name}
            children={item.children}
            classes={item.classes}
            color={item.color}
            component={item.component}
            disabled={item.disabled}
            disableElevation={item.disableElevation}
            disableFocusRipple={item.disableFocusRipple}
            disableRipple={item.disableRipple}
            endIcon={item.endIcon}
            fullWidth={item.fullWidth}
            href={item.href}
            size={item.size}
            startIcon={item.startIcon}
            sx={{ width: item.width || '100%', ...item.sx }}
            variant={item.variant}
            onClick={item.onClick}
            onKeyUp={item.onKeyUp}
            onKeyDown={item.onKeyDown}
            onMouseUp={item.onMouseUp}
            onMouseOver={item.onMouseOver}
            onMouseDown={item.onMouseDown}
            onMouseOut={item.onMouseOut}
          />
        );
      case 'checkbox':
        return (
          <Checkbox
            nameSx={item.nameSx}
            name={item.name}
            disabled={item.disabled}
            labelPlacement={item.labelPlacement}
            checked={item.checked}
            checkedIcon={item.checkedIcon}
            classes={item.classes}
            color={item.color}
            defaultChecked={item.defaultChecked}
            disableRipple={item.disableRipple}
            icon={item.icon}
            id={item.id}
            indeterminate={item.indeterminate}
            indeterminateIcon={item.indeterminateIcon}
            inputProps={item.inputProps}
            inputRef={item.inputRef}
            required={item.required}
            size={!item.size ? 'small' : item.size}
            sx={{ mx: 1, ...item.sx }}
            value={item.value}
            onChange={item.onChange}
          />
        );
      case 'multiCheckBox':
        return <GroupCheckbox row={item.row} items={item.items} sx={item.sx} />;
      case 'combo':
        return (
          <Combo
            items={item.items}
            wrapSx={{
              width: '100%',
              ...item.wrapSx,
            }}
            color={item.color}
            size={!item.size ? 'small' : item.size}
            fullWidth={item.fullWidth}
            required={item.required}
            disabled={item.disabled}
            autoWidth={item.autoWidth}
            classes={item.classes}
            defaultOpen={item.defaultOpen}
            displayEmpty={item.displayEmpty}
            IconComponent={item.IconComponent}
            id={item.id}
            input={item.input}
            inputProps={item.inputProps}
            name={item.name}
            nameId={item.nameId}
            MenuProps={item.MenuProps}
            multiple={item.multiple}
            native={item.native}
            open={item.open}
            SelectDisplayProps={item.SelectDisplayProps}
            sx={{
              fontSize: '0.9rem',
              ...item.sx,
            }}
            value={item.value}
            variant={item.variant}
            onOpen={item.onOpen}
            onClose={item.onClose}
            onChange={item.onChange}
          />
        );
      case 'datePicker':
        return (
          <DatePicker
            autoFocus={item.autoFocus}
            value={item.value}
            closeOnSelect={item.closeOnSelect}
            defaultValue={item.defaultValue}
            desktopModeMediaQuery={item.desktopModeMediaQuery}
            disabled={item.disabled}
            disableFuture={item.disableFuture}
            disableHighlightToday={item.disableHighlightToday}
            disableOpenPicker={item.disableOpenPicker}
            disablePast={item.disablePast}
            displayWeekNumber={item.displayWeekNumber}
            fixedWeekNumber={item.fixedWeekNumber}
            formatDensity={item.formatDensity}
            inputRef={item.inputRef}
            name={item.name}
            loading={item.loading}
            localeText={item.localeText}
            maxDate={item.maxDate}
            minDate={item.minDate}
            monthsPerRow={item.monthsPerRow}
            open={item.open}
            openTo={item.openTo}
            orientation={item.orientation}
            reduceAnimations={item.reduceAnimations}
            referenceDate={item.referenceDate}
            selectedSections={item.selectedSections}
            showDaysOutsideCurrentMonth={item.showDaysOutsideCurrentMonth}
            slotProps={{
              ...item.slotProps,
              textField: {
                size: 'small',
                InputProps: {
                  sx: { fontSize: '0.9rem' }, // 🔹 폰트 크기 설정
                },
              },
            }}
            slots={item.slots}
            sx={{ ...item.sx }}
            timezone={item.timezone}
            view={item.view}
            views={item.views}
            format={item.format}
            viewRenderers={item.viewRenderers}
            yearsPerRow={item.yearsPerRow}
            dayOfWeekFormatter={item.dayOfWeekFormatter}
            onAccept={item.onAccept}
            onChange={item.onChange}
            onClose={item.onClose}
            onError={item.onError}
            onMonthChange={item.onMonthChange}
            onOpen={item.onOpen}
            onSelectedSectionsChange={item.onSelectedSectionsChange}
            onViewChange={item.onViewChange}
            onYearChange={item.onYearChange}
            renderLoading={item.renderLoading}
            shouldDisableDate={item.shouldDisableDate}
            shouldDisableMonth={item.shouldDisableMonth}
            shouldDisableYear={item.shouldDisableYear}
            currentLocale={item.currentLocale}
          />
        );
      case 'dateTimePicker':
        return (
          <DateTimePicker
            value={item.value}
            onChange={item.onChange}
            format={item.format || 'YYYY-MM-DD HH:mm'}
            views={['year', 'month', 'day', 'hours', 'minutes']}
            slotProps={{
              ...item.slotProps,
              textField: {
                size: 'small',
                InputProps: {
                  sx: { fontSize: '0.9rem' },
                },
              },
            }}
            sx={{ ...item.sx }}
          />
        );
      case 'radio':
        return (
          <Radio
            items={item.items}
            value={item.value}
            row={item.row}
            onChange={item.onChange}
          />
        );
      case 'fradio':
        return (
          <FRadio
            items={item.items}
            value={item.value}
            row={item.row}
            onChange={item.onChange}
          />
        );
      case 'input':
        // 필수입력에 대한 부분
        const isRequired = item.isRequired === true;
        const hasValue = !!item.value;
        const isError = isRequired && !hasValue;

        const isSuccess = isRequired && hasValue;

        const textField = (
          <TextField
            fullWidth
            label={
              isRequired ? (
                <span>
                  <span
                    style={{
                      color: isSuccess ? '#4caf50' : '#f44336', // 값 있으면 초록, 없으면 빨강
                      fontWeight: 'bold',
                    }}
                  >
                    *
                  </span>{' '}
                  {item.label || ''}
                </span>
              ) : (
                item.label || ''
              )
            }
            placeholder={item.placeholder || ''}
            value={item.value || ''}
            onChange={(e) => {
              item.onChange?.(e); // 기본 처리
            }}
            onClick={(e) => (item.onClick ? item.onClick(e) : '')}
            onCompositionStart={(e) => {
              item.onCompositionStart?.(e);
            }}
            onCompositionEnd={(e) => {
              item.onCompositionEnd?.(e); // IME 종료 이벤트만 전달
            }}
            sx={{
              ...item.sx,
              '& .MuiInputBase-input': {
                fontSize: '0.9rem',
              },
              '& .MuiOutlinedInput-root': {
                backgroundColor: isRequired ? '#fffdf5' : undefined,
                '& fieldset': {
                  borderColor: isError
                    ? '#f44336' // 빨간색: 에러
                    : isSuccess
                      ? '#4caf50' // 초록색: 성공
                      : undefined, // 기본
                },
                '&:hover fieldset': {
                  borderColor: isError
                    ? '#f44336'
                    : isSuccess
                      ? '#4caf50'
                      : undefined,
                },
                '&.Mui-focused fieldset': {
                  borderColor: isError
                    ? '#f44336'
                    : isSuccess
                      ? '#4caf50'
                      : '#1976d2', // 기본 포커스 색
                },
                '&.Mui-disabled': {
                  // disabled시 처리
                  backgroundColor: '#eeeeee', // 더 밝은 회색
                  borderRadius: '4px',
                  cursor: 'not-allowed',
                  boxShadow: 'inset 0 0 0 1px #cccccc', // 테두리 느낌
                  '& fieldset': {
                    borderColor: '#cccccc', // 테두리 회색
                    borderStyle: 'dashed', // 점선 테두리 느낌
                  },
                },
              },
            }}
            size="small"
            name={item.field}
            rowSpan={item.slotProps || null}
            multiline={item.multiline}
            rows={item.rows}
            inputProps={{
              maxLength: item.maxLength || 100,
              ...item.inputProps,
            }}
            InputProps={item.InputProps}
            disabled={item.disabled}
            inputRef={item.inputRef}
            error={isError}
            helperText={isError ? '필수 입력입니다' : ''}
            onFocus={(e) => {
              item.onFocus?.(e);
            }}
          />
        );

        return item.showTooltip ? (
          <Tooltip
            title={item.value}
            arrow
            enterDelay={300}
            componentsProps={{
              tooltip: {
                sx: {
                  fontSize: '0.9rem',
                  padding: '8px 12px',
                  maxWidth: 500,
                  backgroundColor: '#333',
                  whiteSpace: 'pre-wrap',
                },
              },
            }}
          >
            <div>{textField}</div>
          </Tooltip>
        ) : (
          textField
        );
      case 'number':
        return (
          <TextField
            fullWidth
            type="number"
            value={
              item.value === '' ||
              item.value === null ||
              item.value === undefined
                ? ''
                : item.value
            }
            inputProps={item.inputProps}
            placeholder={item.placeholder}
            onChange={(e) => (item.onChange ? item.onChange(e) : '')}
            onClick={(e) => (item.onClick ? item.onClick(e) : '')}
            sx={{
              ...item.sx,
              '& .MuiInputBase-input': {
                fontSize: '0.9rem',
              },
              backgroundColor: item.disabled ? '#eeeeee' : '#fff', // 더 밝은 회색
              borderRadius: '4px',
              cursor: 'not-allowed',
              '& fieldset': {
                borderColor: '#cccccc', // 테두리 회색
              },
            }}
            disabled={item.disabled}
            size="small"
            name={item.field}
            rowSpan={item.slotProps || null}
          />
        );
      case 'other':
        return <div>{item.item}</div>;
      default:
        return null;
    }
  };

  const gridOptions = {
    singleClickEdit: true,
    rowClassRules: {
      'new-row': (params) => params.data?.newYn === 'Y',
      'delete-row': (params) => params.data?.deleteYn === 'Y',
      'edit-row': (params) =>
        params.data?.editYn === 'Y' && params.data?.newYn !== 'Y',
    },

    // ✅ 필터 활성화 여부를 동적으로 판단
    isExternalFilterPresent: () => {
      const filters = selectedFiltersRef.current || {};
      const hasActiveFilter = Object.values(filters).some(
        (v) => Array.isArray(v) && v.length > 0
      );
      return hasActiveFilter; // 필터 있을 때만 true
    },

    // ✅ 필터가 켜진 상태일 때만 적용
    doesExternalFilterPass(node) {
      const filters = selectedFiltersRef.current || {};
      const hasActiveFilter = Object.values(filters).some(
        (v) => Array.isArray(v) && v.length > 0
      );

      if (!hasActiveFilter) {
        // 필터 없으면 모든 행 표시 (드래그 가능)
        return true;
      }

      // 필터 있을 때만 필터링 적용
      if (node.data?.newYn === 'Y') return true;
      if (node.data?.deleteYn === 'Y') return true;

      return Object.keys(filters).every((field) => {
        const values = filters[field] || [];
        if (values.length === 0) return true;
        return values.includes(node.data[field]);
      });
    },
  };

  const LeftSideButtons = () => {
    return (
      <MuiCard
        sx={{
          flexShrink: 0, // 공간이 부족해도 이 요소는 유지(영역이 줄어들지 않음)
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'space-between',
          alignItems: 'center',
          pb: 1,
          boxShadow: 'none',
          overflow: 'visible',
          ...buttonsSx1,
        }}
      >
        {/* 제목 + 필터 한 그룹 */}
        <MuiBox sx={{ display: 'flex', alignItems: 'center' }}>
          <Typography
            sx={{
              fontSize: '1.05rem',
              fontWeight: 'bold',
              color: '#2CA900',
              mr: 1, // 오른쪽으로 16px 여백
            }}
          >
            {title1}
          </Typography>

          {gridRef && (
            <GridFilterButton
              gridRef={gridRef}
              gridApi={gridApi}
              gridColumnApi={gridColumnApi}
              rowData={rowData}
              selectedFiltersRef={selectedFiltersRef}
              selectedFilters={selectedFilters}
              setSelectedFilters={setSelectedFilters}
              setIsFiltered={setIsFiltered}
              setHeaderMap={setHeaderMap}
              headerMap={headerMap}
            />
          )}
        </MuiBox>

        <MuiBox sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, my: 1.3 }}>
          {/* other 버튼 스타일 sx={{ m: 1, color: "#2196F3", borderColor: "#2196F3" }} */}
          {other1 && other1}
          {copyYn1 === 'Y' && (
            <MuiButton
              sx={{
                color: '#2196F3',
                borderColor: '#2196F3',
              }}
              size={''}
              variant="outlined"
              onClick={copyClick1}
            >
              <CopyrightIcon fontSize={''} />
              복사
            </MuiButton>
          )}
          {applyYn1 === 'Y' && (
            <>
              <MuiButton
                sx={{
                  color: '#2196F3',
                  borderColor: '#2196F3',
                }}
                size={''}
                variant="outlined"
                onClick={applyClick1}
              >
                {applyName1}
              </MuiButton>
              <MuiButton
                sx={{
                  color: '#2196F3',
                  borderColor: '#2196F3',
                }}
                size={''}
                variant="outlined"
                onClick={applyCancleClick1}
              >
                {applyCancleName1}
              </MuiButton>
            </>
          )}
          {searchYn1 === 'Y' && (
            <MuiButton
              sx={{
                color: '#2196F3',
                borderColor: '#2196F3',
              }}
              size={''}
              variant="outlined"
              onClick={searchClick1}
            >
              <SearchIcon fontSize={''} />
              검색
            </MuiButton>
          )}
          {addYn1 === 'Y' && (
            <motion.div
              animate={isAddButtonError ? { y: [0, -20, 0, -10, 0] } : { y: 0 }}
              transition={
                isAddButtonError
                  ? {
                      duration: 0.6,
                      repeat: Infinity,
                      repeatDelay: 1,
                      ease: 'easeOut',
                    }
                  : { duration: 0 }
              }
            >
              <LargeTooltip title="추가" arrow placement="top">
                <IconButton
                  color="primary"
                  sx={{
                    border: 1,
                  }}
                  size={''}
                  variant="outlined"
                  onClick={() => {
                    dispatch(resetAddButtonError());
                    addClick1();
                  }}
                >
                  <AddIcon fontSize={''} style={{ margin: 0 }} />
                </IconButton>
              </LargeTooltip>
            </motion.div>
          )}
          {saveYn1 === 'Y' && (
            <MuiButton
              sx={{
                color: '#2CA900',
                borderColor: '#2CA900',
              }}
              size={''}
              variant="outlined"
              onClick={saveClick1}
            >
              <SaveIcon fontSize={''} />
              저장
            </MuiButton>
          )}
          {refreshYn1 === 'Y' && (
            <LargeTooltip title="검색" arrow placement="top">
              <IconButton
                color="secondary"
                sx={{
                  border: 1,
                }}
                size={''}
                variant="outlined"
                onClick={refreshClick1}
              >
                <RefreshIcon fontSize={''} style={{ margin: 0 }} />
              </IconButton>
            </LargeTooltip>
          )}
          {deleteYn1 === 'Y' && (
            <LargeTooltip title="삭제" arrow placement="top">
              <IconButton
                color="error"
                sx={{
                  // color: "#D32F2F",
                  // borderColor: "#D32F2F",
                  border: 1,
                }}
                size={''}
                variant="outlined"
                //onClick={deleteClick1}
                onClick={() => {
                  if (proId == 'SAC_BASIC') {
                    if (!validateSelection()) return;
                    setDialogToggle1({
                      ...dialogToggle1,
                      open: true,
                      title: '삭제',
                      content: [
                        <MuiBox
                          key="delete-warning"
                          sx={{
                            height: '100%',
                            width: '400px',
                          }}
                        >
                          <Typography>
                            회의록 삭제 시 하위 안건내용도 전체삭제가 됩니다.
                            삭제하시겠습니까?
                          </Typography>
                        </MuiBox>,
                      ],
                    });
                  } else {
                    deleteClick1();
                  }
                }}
              >
                <DeleteIcon fontSize={''} style={{ margin: 0 }} />
              </IconButton>
            </LargeTooltip>
          )}
          {printYn1 === 'Y' && multiPrintYn1 === 'Y' ? (
            <div>
              <MuiButton
                ref={anchorRef1}
                id="composition-button"
                aria-controls={open1 ? 'composition-menu' : undefined}
                aria-expanded={open1 ? 'true' : undefined}
                aria-haspopup="true"
                sx={{
                  m: 1,
                  color: '#9370DB',
                  borderColor: '#9370DB',
                }}
                size={''}
                variant="outlined"
                onClick={HandleToggle1}
              >
                <PrintIcon fontSize={''} />
                인쇄
              </MuiButton>
              <Popper
                open={open1}
                anchorEl={anchorRef1.current}
                role={undefined}
                placement="bottom-start"
                transition
                disablePortal
                sx={{ zIndex: 1300 }}
              >
                {({ TransitionProps, placement }) => (
                  <Grow
                    {...TransitionProps}
                    style={{
                      transformOrigin:
                        placement === 'bottom-start'
                          ? 'left top'
                          : 'left bottom',
                    }}
                  >
                    <Paper>
                      <ClickAwayListener onClickAway={HandleClose1}>
                        <MenuList
                          autoFocusItem={open1}
                          id="composition-menu"
                          aria-labelledby="composition-button"
                          onKeyDown={HandleListKeyDown1}
                        >
                          {printItem1.map((_item, _index) => {
                            return (
                              <>
                                <MenuItem
                                  key={_index}
                                  onClick={(e) => {
                                    _item.onClick();
                                    HandleClose1(e);
                                  }}
                                  sx={{
                                    fontSize: '14px',
                                  }}
                                >
                                  {_item.name}
                                </MenuItem>
                                {_index < printItem1.length - 1 && <Divider />}
                              </>
                            );
                          })}
                        </MenuList>
                      </ClickAwayListener>
                    </Paper>
                  </Grow>
                )}
              </Popper>
            </div>
          ) : printYn1 === 'Y' ? (
            <MuiButton
              sx={{
                m: 1,
                color: '#9370DB',
                borderColor: '#9370DB',
              }}
              size={''}
              variant="outlined"
              onClick={printClick1}
            >
              <PrintIcon fontSize={''} />
              인쇄
            </MuiButton>
          ) : (
            <></>
          )}
          {fileUploadYn1 === 'Y' && (
            <LargeTooltip title="엑셀업로드" arrow placement="top">
              <IconButton
                color="secondary"
                ref={anchorRef1}
                id="composition-button"
                aria-controls={open1 ? 'composition-menu' : undefined}
                aria-expanded={open1 ? 'true' : undefined}
                aria-haspopup="true"
                sx={{
                  border: 1,
                }}
                variant="outlined"
                size={''}
                onClick={fileUploadClick1}
              >
                <FileUploadIcon fontSize={''} />
              </IconButton>
            </LargeTooltip>
          )}
          {fileDownloadYn1 === 'Y' && (
            <LargeTooltip title="엑셀다운로드" arrow placement="top">
              <IconButton
                color="success"
                sx={{
                  border: 1,
                }}
                size={''}
                variant="outlined"
                onClick={fileDownloadClick1}
              >
                <Icon.FolderDownload
                  fontSize={Commons.IsMobile() ? 'small' : ''}
                />
              </IconButton>
            </LargeTooltip>
          )}
          {!other1 &&
            copyYn1 === 'N' &&
            applyYn1 === 'N' &&
            searchYn1 === 'N' &&
            addYn1 === 'N' &&
            saveYn1 === 'N' &&
            deleteYn1 === 'N' &&
            printYn1 === 'N' &&
            fileUploadYn1 === 'N' &&
            refreshYn1 === 'N' && (
              <MuiButton
                sx={{
                  m: 1,
                  opacity: 0, // 투명
                  pointerEvents: 'none', // 클릭 방지
                  borderColor: 'transparent',
                }}
                variant="outlined"
              >
                빈 버튼
              </MuiButton>
            )}
        </MuiBox>
      </MuiCard>
    );
  };

  const RightSideButtons = () => (
    <MuiCard
      sx={{
        flexShrink: 0, // 공간이 부족해도 이 요소는 유지(영역이 줄어들지 않음)
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        alignItems: 'center',
        pb: 1,
        boxShadow: 'none',
        ...buttonsSx2,
      }}
    >
      {/* 제목 + 필터 한 그룹 */}
      <MuiBox sx={{ display: 'flex', alignItems: 'center' }}>
        <Typography
          sx={{
            fontSize: '1.05rem',
            fontWeight: 'bold',
            color: '#2CA900',
            mr: 1, // 오른쪽으로 16px 여백
          }}
        >
          {title2}
        </Typography>

        {gridRef2 && (
          <GridFilterButton
            gridRef={gridRef2}
            gridApi={gridApi}
            gridColumnApi={gridColumnApi}
            rowData={rowData}
            selectedFilters={selectedFilters}
            setSelectedFilters={setSelectedFilters}
            setIsFiltered={setIsFiltered}
            setHeaderMap={setHeaderMap}
            headerMap={headerMap}
          />
        )}
      </MuiBox>

      <MuiBox sx={{ display: 'flex', flexWrap: 'wrap', m: 1 }}>
        {/* other 버튼 스타일 sx={{ m: 1, color: "#2196F3", borderColor: "#2196F3" }} */}
        {other2 && other2}
        {copyYn2 === 'Y' && (
          <MuiButton
            sx={{ m: 1, color: '#2196F3', borderColor: '#2196F3' }}
            size={''}
            variant="outlined"
            onClick={copyClick2}
          >
            <CopyrightIcon fontSize={''} />
            복사
          </MuiButton>
        )}
        {applyYn2 === 'Y' && (
          <>
            <MuiButton
              sx={{
                m: 1,
                color: '#2196F3',
                borderColor: '#2196F3',
              }}
              size={''}
              variant="outlined"
              onClick={applyClick2}
            >
              {applyName2}
            </MuiButton>
            <MuiButton
              sx={{
                m: 1,
                color: '#2196F3',
                borderColor: '#2196F3',
              }}
              size={''}
              variant="outlined"
              onClick={applyCancleClick2}
            >
              {applyCancleName2}
            </MuiButton>
          </>
        )}
        {searchYn2 === 'Y' && (
          <MuiButton
            sx={{ m: 1, color: '#2196F3', borderColor: '#2196F3' }}
            size={''}
            variant="outlined"
            onClick={searchClick2}
          >
            <SearchIcon fontSize={''} />
            검색
          </MuiButton>
        )}
        {addYn2 === 'Y' && (
          <motion.div
            animate={isAddButtonError ? { y: [0, -20, 0, -10, 0] } : { y: 0 }}
            transition={
              isAddButtonError
                ? {
                    duration: 0.6,
                    repeat: Infinity,
                    repeatDelay: 1,
                    ease: 'easeOut',
                  }
                : { duration: 0 }
            }
          >
            <LargeTooltip title="추가" arrow placement="top">
              <IconButton
                color="primary"
                sx={{
                  m: 1,
                  border: 1,
                }}
                size={''}
                variant="outlined"
                onClick={() => {
                  dispatch(resetAddButtonError());
                  addClick2();
                }}
              >
                <AddIcon fontSize={''} style={{ margin: 0 }} />
              </IconButton>
            </LargeTooltip>
          </motion.div>
        )}
        {saveYn2 === 'Y' && (
          <MuiButton
            sx={{ m: 1, color: '#2CA900', borderColor: '#2CA900' }}
            size={''}
            variant="outlined"
            onClick={saveClick2}
          >
            <SaveIcon fontSize={''} />
            저장
          </MuiButton>
        )}
        {refreshYn2 === 'Y' && (
          <LargeTooltip title="검색" arrow placement="top">
            <IconButton
              color="secondary"
              sx={{
                m: 1,
                border: 1,
              }}
              size={''}
              variant="outlined"
              onClick={refreshClick2}
            >
              <RefreshIcon fontSize={''} style={{ margin: 0 }} />
            </IconButton>
          </LargeTooltip>
        )}
        {deleteYn2 === 'Y' && (
          <LargeTooltip title="삭제" arrow placement="top">
            <IconButton
              color="error"
              sx={{
                m: 1,
                // color: "#D32F2F",
                // borderColor: "#D32F2F",
                border: 1,
              }}
              size={''}
              variant="outlined"
              onClick={() => {
                deleteClick2();
              }}
            >
              <DeleteIcon fontSize={''} style={{ margin: 0 }} />
            </IconButton>
          </LargeTooltip>
        )}
        {printYn2 === 'Y' && multiPrintYn2 === 'Y' ? (
          <div>
            <MuiButton
              ref={anchorRef2}
              id="composition-button"
              aria-controls={open2 ? 'composition-menu' : undefined}
              aria-expanded={open2 ? 'true' : undefined}
              aria-haspopup="true"
              sx={{
                m: 1,
                color: '#9370DB',
                borderColor: '#9370DB',
              }}
              size={''}
              variant="outlined"
              onClick={HandleToggle2}
            >
              <PrintIcon fontSize={''} />
              인쇄
            </MuiButton>
            <Popper
              open={open2}
              anchorEl={anchorRef2.current}
              role={undefined}
              placement="bottom-start"
              transition
              disablePortal
              sx={{ zIndex: 1300 }}
            >
              {({ TransitionProps, placement }) => (
                <Grow
                  {...TransitionProps}
                  style={{
                    transformOrigin:
                      placement === 'bottom-start' ? 'left top' : 'left bottom',
                  }}
                >
                  <Paper>
                    <ClickAwayListener onClickAway={HandleClose2}>
                      <MenuList
                        autoFocusItem={open2}
                        id="composition-menu"
                        aria-labelledby="composition-button"
                        onKeyDown={HandleListKeyDown2}
                      >
                        {printItem2.map((_item, _index) => {
                          return (
                            <>
                              <MenuItem
                                key={_index}
                                onClick={(e) => {
                                  _item.onClick();
                                  HandleClose2(e);
                                }}
                                sx={{
                                  fontSize: '14px',
                                }}
                              >
                                {_item.name}
                              </MenuItem>
                              {_index < printItem2.length - 1 && <Divider />}
                            </>
                          );
                        })}
                      </MenuList>
                    </ClickAwayListener>
                  </Paper>
                </Grow>
              )}
            </Popper>
          </div>
        ) : printYn2 === 'Y' ? (
          <MuiButton
            sx={{ m: 1, color: '#9370DB', borderColor: '#9370DB' }}
            size={''}
            variant="outlined"
            onClick={printClick2}
          >
            <PrintIcon fontSize={''} />
            인쇄
          </MuiButton>
        ) : (
          <></>
        )}
        {fileUploadYn2 === 'Y' && (
          <MuiButton
            ref={anchorRef2}
            id="composition-button"
            aria-controls={open2 ? 'composition-menu' : undefined}
            aria-expanded={open2 ? 'true' : undefined}
            aria-haspopup="true"
            sx={{ m: 1, color: '#2196F3', borderColor: '#2196F3' }}
            variant="outlined"
            size={''}
            onClick={fileUploadClick2}
          >
            <FileUploadIcon fontSize={''} />
            파일 업로드
          </MuiButton>
        )}
        {!other2 &&
          copyYn2 === 'N' &&
          applyYn2 === 'N' &&
          searchYn2 === 'N' &&
          addYn2 === 'N' &&
          saveYn2 === 'N' &&
          deleteYn2 === 'N' &&
          printYn2 === 'N' &&
          fileUploadYn2 === 'N' &&
          refreshYn2 === 'N' && (
            <MuiButton
              sx={{
                m: 1,
                opacity: 0, // 투명
                pointerEvents: 'none', // 클릭 방지
                borderColor: 'transparent',
              }}
              variant="outlined"
            >
              빈 버튼
            </MuiButton>
          )}
      </MuiBox>
    </MuiCard>
  );

  return (
    <Box sx={{ height: '100%' }}>
      <Split
        sizes={[leftSize, rightSize]} // 초기 비율
        minSize={150} // 최소 크기
        expandToMin={false} // 최소 크기보다 작아지지 않도록 설정
        gutterSize={10} // 드래그 바 크기
        gutterAlign="center"
        cursor="col-resize"
        className="split-container"
        sx={{ backgroundColor: '#FFF' }}
      >
        {/* 왼쪽 영역 */}
        {gridSide === 'left' ? (
          <Box
            sx={{
              width: '100%',
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
              borderColor: 'divider',
              borderRadius: '10px',
              p: 2,
              pt: 1,
              backgroundColor: '#FFF',
            }}
          >
            {LeftSideButtons()}
            {/* 필터 요약 바 */}
            {gridRef && (
              <GridFilterSummary
                isFiltered={isFiltered}
                selectedFilters={selectedFilters}
                headerMap={headerMap}
                setSelectedFilters={setSelectedFilters}
              />
            )}
            <AgGridReact
              getRowId={getRowId}
              ref={gridRef}
              onGridReady={(params) => {
                setGridApi(params.api);
                setGridColumnApi(params.columnApi);
              }}
              animationRows={true}
              columnDefs={columnDefs}
              rowData={rowData}
              defaultColDef={{
                cellDataType: false,
                minWidth: 100,
                editable: editable,
                resizable: true,
                sortable: true,
                filter: true,
                // floatingFilter: true,
              }}
              gridOptions={gridOptions}
              suppressCellFocus={suppressCellFocus}
              stopEditingWhenCellsLoseFocus={true} //마우스로 외부 클릭 시 cell 닫힘
              rowSelection="multiple"
              // getRowStyle={(e) => GridFunctions.getRowStyle(e)}
              onSelectionChanged={() => {
                if (onSelectionChanged) {
                  onSelectionChanged(gridRef);
                } else {
                  GridFunctions.onSelectionChanged(gridRef, (_selected) => {
                    setSelectedRowData(_selected);
                  });
                }
              }}
              // onSelectionChanged={() => {
              //   const api = gridRef.current?.api;
              //   if (!api) return;
              //   const selectedNodes = api.getSelectedNodes();
              //   const selectedData = selectedNodes.map((node) => node.data);

              //   if (onSelectionChanged) {
              //     onSelectionChanged(gridRef);
              //   } else {
              //     dispatch(setSelected({ gridId, selected: selectedData }));
              //   }
              // }}
              autoGroupColumnDef={autoGroupColumnDef}
              onCellValueChanged={(e) => {
                if (onCellValueChanged) {
                  onCellValueChanged(e, gridRef);
                } else {
                  GridFunctions.onCellValueChanged(
                    e,
                    gridRef,
                    setChangedRowData
                  );
                }
              }}
              // onCellValueChanged={(e) => {
              //   if (onCellValueChanged) {
              //     onCellValueChanged(e, gridRef);
              //   } else {
              //     GridFunctions.onCellValueChanged(e, gridRef, (newChanged) => {
              //       dispatch(setChanged({ gridId, changed: newChanged }));
              //     });
              //   }
              // }}
              onCellClicked={onCellClicked}
              rowDragManaged={rowDragManaged} // Drag True/False
              onRowDragEnd={onRowDragEnd} // Drag End Event
              pagination={pagination} // enable pagination
              paginationPageSize={100} // sets 10 rows per page (default is 100)
              paginationPageSizeSelector={[100, 200, 500, 1000]} // allows the user to select the page size from a predefined list of page sizes
              localeText={{
                // 기본 텍스트
                page: '페이지',
                more: '더보기',
                to: '~',
                of: '/',
                next: '다음',
                last: '마지막',
                first: '처음',
                previous: '이전',
                loadingOoo: '불러오는 중...',

                // 필터 & 패널 등
                selectAll: '전체 선택',
                searchOoo: '검색...',
                blanks: '공백',

                // 페이지 사이즈 선택기
                pageSizeSelectorLabel: '페이지 당 행 수',

                // 기본 페이지네이션 설명
                paginationPageSize: '페이지 당 행 수',
                paginationNumberFormatter: (params) => `${params.value}`,
              }}
            />
          </Box>
        ) : (
          <Box
            sx={{
              width: '100%',
              height: '100%',
              borderColor: 'divider',
              borderRadius: '10px',
              p: 2,
              pt: 1,
              backgroundColor: '#FFF',
            }}
          >
            <Stack
              sx={{
                width: '100%',
                height: '100%',
                overflow: 'auto',
              }}
            >
              <React.Fragment>
                {LeftSideButtons()}
                <TableContainer
                  component={Paper}
                  sx={{
                    overflow: 'auto',
                    '&::-webkit-scrollbar': {
                      width: '8px',
                      height: '8px', // 가로 스크롤바도 동일한 높이로 설정
                    },
                    '&::-webkit-scrollbar-thumb': {
                      backgroundColor: 'rgba(0, 0, 0, 0.1)', // 스크롤바 색상
                      borderRadius: '4px',
                    },
                    '&::-webkit-scrollbar-track': {
                      backgroundColor: '#f1f1f1', // 스크롤바 트랙 색상
                    },
                    border: 1,
                    borderColor: 'divider',
                    borderRadius: '8px',
                  }}
                >
                  <Table>
                    <colgroup>
                      {!colWidth || colWidth.length === 0 ? (
                        <React.Fragment></React.Fragment>
                      ) : (
                        colWidth.map((_item, _index) => {
                          return (
                            <col
                              key={_index}
                              style={{
                                width: _item,
                              }}
                            />
                          );
                        })
                      )}
                    </colgroup>
                    <TableBody>
                      {!tableData || tableData.length === 0 ? (
                        <React.Fragment></React.Fragment>
                      ) : (
                        tableData.map((row, rowIndex) => (
                          <TableRow
                            key={rowIndex}
                            sx={{
                              ...row.sx,
                              borderRight: 1,
                              borderColor: 'divider',

                              fontSize: '1.05rem',
                            }}
                          >
                            {row.cells.map((cell, cellIndex) => (
                              <TableCell
                                key={cellIndex}
                                align={cell.align || 'center'}
                                sx={{
                                  width: cell.width || 'auto',
                                  ...cell.sx,
                                  borderRight: 1,
                                  borderColor: 'divider',
                                  fontSize: '0.9rem',
                                  backgroundColor: !cell.type
                                    ? 'rgb(250, 250, 250)'
                                    : '#fff',
                                  fontWeight: !cell.type ? 'bold' : '',
                                }}
                                colSpan={cell.colSpan || 1}
                                rowSpan={cell.rowSpan || 1}
                              >
                                {cell.gubun === 'I' ? (
                                  TableConditions(cell)
                                ) : (
                                  <span
                                    dangerouslySetInnerHTML={{
                                      __html: cell.content || '',
                                    }}
                                  />
                                )}
                              </TableCell>
                            ))}
                          </TableRow>
                        ))
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </React.Fragment>
            </Stack>
          </Box>
        )}
        {/* 오른쪽 영역 */}
        {gridSide === 'right' ? (
          <Box
            sx={{
              width: '100%',
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
              borderColor: 'divider',
              borderRadius: '10px',
              p: 2,
              pt: 1,
              backgroundColor: '#FFF',
            }}
          >
            {RightSideButtons()}
            {/* 필터 요약 바 */}
            {gridRef2 && (
              <GridFilterSummary
                isFiltered={isFiltered}
                selectedFilters={selectedFilters}
                headerMap={headerMap}
                setSelectedFilters={setSelectedFilters}
              />
            )}
            <AgGridReact
              getRowId={getRowId}
              ref={gridRef2}
              onGridReady={(params) => {
                setGridApi(params.api);
                setGridColumnApi(params.columnApi);
              }}
              animationRows={true}
              columnDefs={columnDefs}
              rowData={rowData}
              defaultColDef={{
                cellDataType: false, // 데이터 추론 막음
                minWidth: 100,
                editable: editable,
                resizable: true,
                sortable: true,
                filter: true,
                // floatingFilter: true,
              }}
              gridOptions={gridOptions}
              stopEditingWhenCellsLoseFocus={true} //마우스로 외부 클릭 시 cell 닫힘
              rowSelection="multiple"
              // getRowStyle={(e) => GridFunctions.getRowStyle(e)}
              onSelectionChanged={() => {
                if (onSelectionChanged) {
                  onSelectionChanged(gridRef2);
                } else {
                  GridFunctions.onSelectionChanged(gridRef2, (_selected) => {
                    setSelectedRowData(_selected);
                  });
                }
              }}
              autoGroupColumnDef={autoGroupColumnDef}
              onCellValueChanged={(e) => {
                if (onCellValueChanged) {
                  onCellValueChanged(e, gridRef2);
                } else {
                  GridFunctions.onCellValueChanged(
                    e,
                    gridRef2,
                    setChangedRowData
                  );
                }
              }}
              onCellClicked={onCellClicked}
              rowDragManaged={rowDragManaged} // Drag True/False
              onRowDragEnd={onRowDragEnd} // Drag End Event
              pagination={pagination} // enable pagination
              paginationPageSize={100} // sets 10 rows per page (default is 100)
              paginationPageSizeSelector={[100, 200, 500, 1000]} // allows the user to select the page size from a predefined list of page sizes
              localeText={{
                // 기본 텍스트
                page: '페이지',
                more: '더보기',
                to: '~',
                of: '/',
                next: '다음',
                last: '마지막',
                first: '처음',
                previous: '이전',
                loadingOoo: '불러오는 중...',

                // 필터 & 패널 등
                selectAll: '전체 선택',
                searchOoo: '검색...',
                blanks: '공백',

                // 페이지 사이즈 선택기
                pageSizeSelectorLabel: '페이지 당 행 수',

                // 기본 페이지네이션 설명
                paginationPageSize: '페이지 당 행 수',
                paginationNumberFormatter: (params) => `${params.value}`,
              }}
            />
          </Box>
        ) : (
          <Box
            sx={{
              width: '100%',
              height: '100%',
              borderColor: 'divider',
              borderRadius: '10px',
              p: 2,
              pt: 1,
              backgroundColor: '#FFF',
            }}
          >
            <Stack
              sx={{
                width: '100%',
                height: '100%',
                overflow: 'auto',
              }}
            >
              <React.Fragment>
                {RightSideButtons()}
                {/* 조건 분기 */}
                {((tableData.length > 0 && !previewRender) ||
                  (tableData.length > 0 &&
                    previewRender &&
                    viewMode === 'table')) && (
                  // 테이블 렌더링
                  <TableContainer
                    component={Paper}
                    sx={{
                      overflow: 'auto',
                      '&::-webkit-scrollbar': {
                        width: '8px',
                        height: '8px', // 가로 스크롤바도 동일한 높이로 설정
                      },
                      '&::-webkit-scrollbar-thumb': {
                        backgroundColor: 'rgba(0, 0, 0, 0.1)', // 스크롤바 색상
                        borderRadius: '4px',
                      },
                      '&::-webkit-scrollbar-track': {
                        backgroundColor: '#f1f1f1', // 스크롤바 트랙 색상
                      },
                      border: 1,
                      borderColor: 'divider',
                      borderRadius: '8px',
                    }}
                  >
                    <Table>
                      <colgroup>
                        {!colWidth || colWidth.length === 0 ? (
                          <React.Fragment></React.Fragment>
                        ) : (
                          colWidth.map((_item, _index) => {
                            return (
                              <col
                                key={_index}
                                style={{
                                  width: _item,
                                }}
                              />
                            );
                          })
                        )}
                      </colgroup>
                      <TableBody>
                        {!tableData || tableData.length === 0 ? (
                          <React.Fragment></React.Fragment>
                        ) : (
                          tableData.map((row, rowIndex) => (
                            <TableRow
                              key={rowIndex}
                              sx={{
                                ...row.sx,
                                borderRight: 1,
                                borderColor: 'divider',
                                fontSize: '1.05rem',
                              }}
                            >
                              {row.cells.map((cell, cellIndex) => (
                                <TableCell
                                  key={cellIndex}
                                  align={
                                    cell.align === 'start'
                                      ? 'left'
                                      : cell.align === 'end'
                                        ? 'right'
                                        : cell.align || 'center'
                                  }
                                  sx={{
                                    ...cell.sx,
                                    borderRight: 1,
                                    borderColor: 'divider',
                                    fontSize: '0.9rem',
                                    backgroundColor: !cell.type
                                      ? 'rgb(250, 250, 250)'
                                      : '#fff',
                                    fontWeight: !cell.type ? 'bold' : '',
                                  }}
                                  colSpan={cell.colSpan || 1}
                                  rowSpan={cell.rowSpan || 1}
                                >
                                  {cell.gubun === 'I' ? (
                                    TableConditions(cell)
                                  ) : (
                                    <span
                                      style={{
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                      }}
                                    >
                                      {cell.field && (
                                        <span
                                          style={{
                                            color: 'red',
                                            marginRight: 4,
                                          }}
                                        >
                                          *
                                        </span>
                                      )}
                                      {typeof cell.content === 'string' ? (
                                        <span
                                          dangerouslySetInnerHTML={{
                                            __html: cell.content || '',
                                          }}
                                        />
                                      ) : (
                                        cell.content
                                      )}
                                    </span>
                                  )}
                                </TableCell>
                              ))}
                            </TableRow>
                          ))
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                )}
                {/* 미리보기 렌더링 */}
                {(previewRender && tableData.length === 0) ||
                viewMode === 'preview' ? (
                  <Box
                    sx={{
                      height: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                      flexGrow: 1,
                      alignItems: 'center',
                      justifyContent: 'center',
                      overflow: 'hidden',
                      p: 1,
                      gap: 2,
                      border: 1,
                      borderColor: 'divider',
                      borderRadius: '8px',
                    }}
                  >
                    {previewRender ? (
                      previewRender()
                    ) : viewMode === 'preview' ? (
                      <FilePreview
                        selectedRowData={selectedRowData}
                        fileNameField={fileNameField}
                        filePathField={filePathField}
                        filePreviewHeight={filePreviewHeight}
                      />
                    ) : (
                      <Typography>미리보기 영역</Typography>
                    )}
                  </Box>
                ) : null}
              </React.Fragment>
            </Stack>
          </Box>
        )}
      </Split>
      <Dialog
        sx={{ height: '100%' }}
        open={dialogToggle1.open}
        onClose={() => setDialogToggle1(false)}
        TransitionComponent={Transition}
        title={dialogToggle1.title}
        content={dialogToggle1.content}
        contentText={dialogToggle1.contentText}
        actions={dialogToggle1.actions}
        useSaveAfterClose={true}
        useSaveButton={true}
        useCloseButton={true}
        saveButtonName={'삭제'}
        closeButtonName={'닫기'}
        onSave={deleteClick1}
      />
      <Dialog
        sx={{ height: '100%' }}
        open={dialogToggle2.open}
        onClose={() => setDialogToggle2(false)}
        TransitionComponent={Transition}
        title={dialogToggle2.title}
        content={dialogToggle2.content}
        contentText={dialogToggle2.contentText}
        actions={dialogToggle2.actions}
        useSaveAfterClose={true}
        useSaveButton={true}
        useCloseButton={true}
        saveButtonName={'삭제'}
        closeButtonName={'닫기'}
        onSave={deleteClick2}
      />
    </Box>
  );
}

export default BusinessCommon;
